import { Component } from '@angular/core';

@Component({ selector: 'app-equipment-management', templateUrl: './equipment-management.component.html', styleUrl: './equipment-management.component.css' })
export class EquipmentManagementComponent {
  activeTab = 'list';

  equipmentTypes = [
    { id: 1, name: 'LED Display',     description: 'High-brightness LED panels',      count: 24, status: 'active'   },
    { id: 2, name: 'Media Player',    description: 'Digital signage media players',    count: 18, status: 'active'   },
    { id: 3, name: 'Video Wall',      description: 'Multi-panel video wall units',     count:  6, status: 'active'   },
    { id: 4, name: 'Kiosk',           description: 'Interactive touch kiosks',         count: 12, status: 'inactive' },
    { id: 5, name: 'Outdoor Screen',  description: 'Weatherproof outdoor displays',    count:  8, status: 'active'   },
  ];

  equipmentList = [
    { id: 1, name: 'LED-001', type: 'LED Display',    location: 'Head Office',    serial: 'SN-LED-0001', status: 'online'   },
    { id: 2, name: 'MP-002',  type: 'Media Player',   location: 'West Branch',    serial: 'SN-MP-0002',  status: 'online'   },
    { id: 3, name: 'VW-003',  type: 'Video Wall',     location: 'South Campus',   serial: 'SN-VW-0003',  status: 'offline'  },
    { id: 4, name: 'KSK-004', type: 'Kiosk',          location: 'North Hub',      serial: 'SN-KSK-004',  status: 'online'   },
    { id: 5, name: 'OUT-005', type: 'Outdoor Screen', location: 'East Wing',      serial: 'SN-OUT-005',  status: 'offline'  },
    { id: 6, name: 'LED-006', type: 'LED Display',    location: 'Downtown Center',serial: 'SN-LED-0006', status: 'online'   },
  ];

  equipmentGroups = [
    { id: 1, name: 'Lobby Displays',   count:  8, location: 'Head Office',  status: 'active'   },
    { id: 2, name: 'Conference Rooms', count: 12, location: 'West Branch',  status: 'active'   },
    { id: 3, name: 'Outdoor Network',  count:  5, location: 'East Wing',    status: 'inactive' },
    { id: 4, name: 'Kiosk Network',    count:  6, location: 'North Hub',    status: 'active'   },
    { id: 5, name: 'Retail Displays',  count: 10, location: 'South Campus', status: 'active'   },
  ];
}
